import React, {useEffect, useRef, useState} from 'react';
import {UsePermissions} from "../../../hooks/usePermissions";
import {Toast} from "primereact/toast";
import {AutoComplete} from "primereact/autocomplete";
import {getClients} from "../../../api/factura.service";
import {TableFactura} from "./TableFactura";
import {Navigate} from "react-router";
import {ModalNuevaFactura} from "./facturas/ModalNuevaFactura";
import {ModalEditarFactura} from "./facturas/ModalEditarFactura";


export const SeccionFactura = () => {
    const [permisos] = UsePermissions();
    const toast = useRef(null);
    const [selectedcliente, setSelectedcliente] = useState({
        id: "",
        nombre: "",
        tipo: ""
    });
    const [displayNewModal, setDisplayNewModal] = useState(false);
    const [displayEditModal, setDisplayEditModal] = useState(false);
    const [fieldEdit, setFieldEdit] = useState({});
    const [clientes, setClientes] = useState([]);
    const [FilteredCliente, setFilteredCliente] = useState(null);
    const [reload, setReload] = useState(false);

    useEffect(() => {
        getClients().then(r => {
            if (r.estado !== 200) {
                return;
            }
            setClientes(r.data)
        }).catch(r => console.log(r))
        return () => {
            if (clientes.length > 0) {
                setClientes([]);
            }
        };
    }, []);


    const searchCliente = (event) => {
        setTimeout(() => {
            let _filteredCliente;
            if (!event.query.trim().length) {
                _filteredCliente = [...clientes];
            } else {
                _filteredCliente = clientes.filter((cliente) => {
                    return cliente.nombre.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredCliente(_filteredCliente);
        }, 250);
    }

    const editarFactura = (e) => {
        console.log(e)
        setFieldEdit({...e});
        setDisplayEditModal(true);
    }

    const onHide = () => {
        setDisplayNewModal(false);
        setReload(true);
        resetLoad();
    }

    const onHideEdit = () => {
        setDisplayEditModal(false);
        setReload(true);
        resetLoad();
    }

    const resetLoad = () => {
        setTimeout(() => {
            setReload(false);
        }, 2000)
    }

    const itemTemplate = (item) => {
        return (
            <div className="flex ">
                <div className="ml-3">{item.nombre}</div>
            </div>
        );
    }

    const nuevaFactura = () => {
        if (selectedcliente.id !== "") {
            setDisplayNewModal(true)
        } else {
            toast.current?.show({
                severity: 'warn',
                summary: 'Alerta',
                detail: "Seleccione un cliente",
                life: 3000
            });

        }
    }
    return (
        <>
            <Toast ref={toast}/>
            {permisos.consultar == 1 && clientes.length > 0 ?
                <div className="w-full mt-2 relative lg:w-4/12 px-4">
                    <AutoComplete value={selectedcliente} suggestions={FilteredCliente}
                                  completeMethod={searchCliente}
                                  placeholder="Buscador clientes"
                                  size="30"
                                  field="nombre" dropdown itemTemplate={itemTemplate}
                                  onChange={(e) => setSelectedcliente(e.value)}/>
                </div>
                : ""}

            <hr className="mt-6 border-b-1 border-blueGray-300"/>
            <div id="factura" className="container-relative mt-2">
                {permisos.consultar == 1 ?
                    <TableFactura
                        reload={reload}
                        nuevaFactura={nuevaFactura}
                        cliente_id={selectedcliente.id ? selectedcliente.id : ""}
                        obtenerParametrosFactura={editarFactura}/>
                    : <Navigate to="/home"/>}

                <ModalNuevaFactura show={displayNewModal}
                                   hide={onHide}
                                   cliente_id={selectedcliente.id !== '' ? selectedcliente.id : ''}
                                   name={selectedcliente.nombre !== '' ? selectedcliente.nombre : ''}
                                   tipo={selectedcliente.tipo !== '' ? selectedcliente.tipo : ''}/>

                <ModalEditarFactura show={displayEditModal} fields={fieldEdit} hide={onHideEdit}/>
            </div>
        </>
    );
};


